module.exports = __webpack_public_path__ + "img/2.139a8297.png";